export default class LoginInvalidError<Data = unknown> extends Error {
  name = 'LoginInvalidError';

  constructor(readonly message = 'Resource Not Found', readonly data?: Data) {
    super(message);
  }
}
